import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


const route = new Router({
  mode:'history',//以便去掉网址中的#
  routes: [
    {
      path: '/payDialog',
      name: 'PayDialog',
      component: resolve => require(["../components/activity/PayDialog"], resolve),
    },
    {
      path: '/login',
      name: 'Login',
      component: resolve => require(["../components/Login"], resolve),
    },
    {
      path: '/logOut',
      name: 'LogOut',
      component: resolve => require(["../components/LogOut"], resolve),
    },
    {
      path: '/error',
      name: 'Error',
      component: resolve => require(["../components/Error"], resolve),
    },
    {
      path: '/activity/luckydraw/:id',
      name: 'luckydraw',
      component: resolve => require(["../components/activity/luckydraw/index"], resolve),
    },
    {
      path: '/activity/minimalism/:id',
      name: 'minimalism',
      component: resolve => require(["../components/activity/luckydraw/minimalism"], resolve),
    },
    {
      path: '/activity/round/:id',
      name: 'round',
      component: resolve => require(["../components/activity/luckydraw/index"], resolve),
    },
    {
      path: '/activity/qiangjinshou/',
      name: 'qiangjinshou',
      component: resolve => require(["../components/activity/qiangjinshou/index"], resolve),
    },
    {
      path: '/activity/luckydraw/prizeList/:id',
      name: 'prizeList',
      component: resolve => require(["../components/activity/luckydraw/prizeList"], resolve),
    },
    {
      path: '/activity/prizeList/:id',
      name: 'publicPrizeList',
      component: resolve => require(["../components/activity/prizeList"], resolve),
    },
    {
      path: '/activity/address/:id',
      name: '',
      component: resolve => require(["../components/activity/address"], resolve),
    },
    {
      path: '/activity/orders/:id',
      name: '',
      component: resolve => require(["../components/activity/orders"], resolve),
    },
    {
      path: '/activity/order/:id',
      name: '',
      component: resolve => require(["../components/activity/order"], resolve),
    },
    {
      path: '/activity/pay/:id',
      name: '',
      component: resolve => require(["../components/activity/pay"], resolve),
    },
    {
      path: '/activity/logistics/:id',
      name: '',
      component: resolve => require(["../components/activity/logistics"], resolve),
    },
    {
      path: '/activity/sign/:id',
      name: 'sign',
      component: resolve => require(["../components/component/signIn/index"], resolve),
    },
    {
      path: '/activity/payment',
      name: 'payment',
      component: resolve => require(["../components/component/payment"], resolve),
    },
    {
      path: '/activity/prize',
      name: 'prize',
      component: resolve => require(["../components/component/prize"], resolve),
    },
    {
      path: '/activity/order',
      name: 'order',
      component: resolve => require(["../components/component/orderAll"], resolve),
    },
    {
      path: '/activity/logistics',
      name: 'logistics',
      component: resolve => require(["../components/component/logistics"], resolve),
    }
  ]
})

//vue 项目在路由切换的时候调用
route.beforeEach(function (to,from,next){
  console.log(`"${from.path}" == to => "${to.path}" ---history:"${history.length}"`)
  localStorage.getItem('configInfo') ? document.title = JSON.parse( localStorage.getItem('configInfo') ).app_name : ''
  //console.log('url1:', document.URL);
  setTimeout(function (){
    next();

    //统计代码开始
    try{
      let app_id = localStorage.getItem("configInfo") ? JSON.parse(localStorage.getItem("configInfo")).app_id : 0;
      let cp_uid = localStorage.getItem("configInfo") ? JSON.parse(localStorage.getItem("configInfo")).cp_uid : 0;
      let app_type = localStorage.getItem("configInfo") ? JSON.parse(localStorage.getItem("configInfo")).app_type : 0;
      xa.registerPage({
        app_id:app_id,
        cp_uid:cp_uid,
        app_type:app_type
      });
      xa.quick("autoTrackSinglePage"); // after the next(); statement
    }catch(e){}
    //统计代码结束
  },0);
});

export default route



// WEBPACK FOOTER //
// ./src/router/index.js